import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { Router } from "@angular/router";
import { Methods } from "../../../shared/methods";
import { LineItem } from "../../../models/lineItem";
import { SaleService } from "../../../services/sale.service";
import swal from "sweetalert2";
import { CrudInventoryComponent } from '../../../modulos/inventory/crud-inventory/crud-inventory.component';

declare const $: any;

declare interface TMP {
  id: number;
  value: string;
}

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css']
})
export class ItemsComponent implements OnInit {
  public mtds: Methods = new Methods();

  @Input() edit: boolean;
  @Input() id: number;
  @Input() so: any;
  @Input() conditions: Array<any> = [];
  @Input() conditions_id;
  @Input() identity;

  @Input() marginPercentage;
  @Input() grossMargin;
  @Input() freight;
  @Input() servichesCharge;
  @Input() misCcharge;
  @Input() tax;
  @Input() subtotal;
  @Input() extendedcost;

  @Output() new_extendedcost: EventEmitter<any>;
  @Output() new_freight: EventEmitter<any>;
  @Output() new_servichesCharge: EventEmitter<any>;
  @Output() new_misCcharge: EventEmitter<any>;
  @Output() new_tax: EventEmitter<any>;
  @Output() new_subtotal: EventEmitter<any>;
  @Output() new_total: EventEmitter<any>;
  @Output() save: EventEmitter<boolean>;
  @Output() status: EventEmitter<string>;

  public lineItem: LineItem = new LineItem();
  public selectedLineItem: any = null;

  public arrayEditDescription: Array<TMP> = [];
  public savingDescription = null;
  public successDescription = null;
  public loadingUnreserveAll = false;
  public loadingUnreserve = false;
  public loadingReserve = false;
  public successUnreserve = false;
  public successReserve = false;
  public saving = false;
  public loading = false;

  public arrayUnreserve: Array<any> = [];
  public lineItems: Array<LineItem> = [];
  public individuales: Array<any> = [];
  public agrupados: Array<any> = [];
  public agrupadosIds: Array<any> = [];
  public agrupadosQty: Array<any> = [];
  public errorArray: any[] = [];
  public editLineItem_id = null;
  public afterValue;
  public typeChange;
  public idx = null;

  public reserveIds: number[] = [];
  public serveLineItem = {
    id: null,
    so: null,
    rep: "",
    assoc: "",
    item: "",
    other: "",
    bulk: false,
    mfgr: "",
    condition: "",
    sellingPrice: "",
    showInTransitItems: true,
    showItemSubstitutea: false,
    showAllConditionsCodes: true,
    qtyToReserve: 1,
    marked: 0,
    balanceToReserve: 1,
    markFirst: 1,
  };

  public total = 0;
  public menos = 0;
  public stock = 0;

  constructor(public dialog: MatDialog, private _router: Router, private _soService: SaleService) {
    this.save = new EventEmitter();
    this.status = new EventEmitter();
    this.new_extendedcost = new EventEmitter();
    this.new_freight = new EventEmitter();
    this.new_servichesCharge = new EventEmitter();
    this.new_misCcharge = new EventEmitter();
    this.new_tax = new EventEmitter();
    this.new_subtotal = new EventEmitter();
    this.new_total = new EventEmitter();
  }

  ngOnInit() {
    this.loading = true;
    this._soService.getLineItems(this.id).subscribe(async (r) => {
      console.log(r);

      this.lineItems = await this.loadItems(r);
      this.loading = false;
    });
  }

  loadItems(r) {
    let item,
      tmp = [];
    for (item of r.lineItems) {
      let element: LineItem;
      element = new LineItem(
        item.id,
        item.so.id,
        item.so.so,
        item.manufacturer,
        this.mtds.booleano(item.clei),
        this.mtds.booleano(item.bulk),
        item.nonInventory,
        item.sellingPrice,
        false,
        item.item,
        item.quantity,
        item.unitPrice,
        item.condition,
        item.total,
        item.height,
        item.type,
        r.line[item.id]
      );
      tmp.push(element);
    }

    return tmp;
  }

  showItem(id) {
    console.log(id);

    const dialogRef = this.dialog.open(CrudInventoryComponent, {
      width: '60%',
      data: id,
    });

    dialogRef.afterClosed().subscribe( (result) => {
      if (result) {
        // this.getData();
      }
    });
  }

  actionLineItems(evento) {
    switch (evento) {
      case "create": {
        this.edit = true;
        this.openModal();
        break;
      }
      case "show": {
        break;
      }
      case "delete": {
        break;
      }
    }
  }

  openModal() {
    this.lineItem = new LineItem();
    this.selectedLineItem = null;
    this.lineItem.SO = this.so;
    this.lineItem.so_id = this.id;
    $("#myModal").modal("show");
  }

  calcularTotal() {
    if (this.lineItem.unitPrice != null && this.lineItem.quantity != null) {
      this.lineItem.total = this.lineItem.quantity * this.lineItem.unitPrice;
    }
  }

  selectLineItem(e) {
    if (e.id) {
      let json;
      json = {
        item: e.item,
        mfgr: e.mfgr,
      };
      this._soService.getStock(json).subscribe((response) => {
        console.log("Stock");
        console.log(response.data);
        this.stock = Number(response.data);
      });

      console.log(e);
      this.selectedLineItem = e;
      this.lineItem.so_id = this.id;
      this.lineItem.item = e.item;
      this.lineItem.manufacturer = e.mfgr;
      this.lineItem.clei = e.clei;
      this.lineItem.bulk = e.bulk;
      this.lineItem.nonInventory = e.nonInventory;
      if (e.unitprice !== null) {
        this.lineItem.unitPrice = e.unitprice;
      }
      this.lineItem.condition = this.conditions_id;
      this.calcularTotal();
    }
  }

  selectScrap(e) {
    if (e.id) {
      console.log(e);
      this.selectedLineItem = e;
      this.lineItem.so_id = this.id;
      this.lineItem.item = e.id;
      this.lineItem.unitPrice = 0;
      this.lineItem.manufacturer = e.categoryId.name;
      this.lineItem.height =
        Number(e.grossWeight) - Number(e.tareWeight) + " lbs";
    }
  }

  agregarLineItem() {
    this.saving = true;
    this._soService.addLineItems(this.lineItem).subscribe(
      (response) => {
        console.log(response);
        if (response.code === 200) {
          this.lineItem.id = response.data.id;
          this.lineItems.push(this.lineItem);

          this.grossMargin = response.grossMarginTotal;
          this.marginPercentage = response.marginPercentage;
          this.tax = response.tax;
          this.subtotal = response.subtotal;
          this.total = response.total;

          this.freight = response.freight;
          this.misCcharge = response.misc_charge;
          this.servichesCharge = response.serviches_charge;

          this.new_freight.emit(response.freight);
          this.new_servichesCharge.emit(response.serviches_charge);
          this.new_misCcharge.emit(response.misc_charge);
          this.new_tax.emit(response.tax);
          this.new_subtotal.emit(response.subtotal);
          this.new_total.emit(response.total);
          this.save.emit(true);

          this.saving = false;
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.closeModal();
        // this.save();
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText);
      }
    );
  }

  checkReserveAny() {
    let item;
    for (item of this.lineItems) {
      if (item.reservedInventories.length > 0) {
        return true;
      }
    }

    return false;
  }

  unreserveAll() {
    swal.fire({
      title: "Unreserve All",
      text: "Are you sure to unreserve all items?",
     
      showCancelButton: true,
      buttonsStyling: false,
     
      customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then(
      function (result) {
        if (result.value) {
          this.loadingUnreserveAll = true;

          this._soService.unreserveAll(this.id).subscribe(
            (response) => {
              console.log(response);
              if (response.code === 200) {
                this.grossMargin = response.grossMarginTotal;
                this.marginPercentage = response.marginPercentage;
                this.tax = response.tax;
                this.subtotal = response.subtotal;
                this.total = response.total;

                this.freight = response.freight;
                this.misCcharge = response.misc_charge;
                this.servichesCharge = response.serviches_charge;

                this.new_freight.emit(response.freight);
                this.new_servichesCharge.emit(response.serviches_charge);
                this.new_misCcharge.emit(response.misc_charge);
                this.new_tax.emit(response.tax);
                this.new_subtotal.emit(response.subtotal);
                this.new_total.emit(response.total);
                this.save.emit(true);
                let i;
                for (i = 0; i < this.lineItems.length; i++) {
                  this.lineItems[i].reservedInventories = [];
                }
                this.mtds.notifySuccess("All reserved items have been removed");
              } else {
                this.mtds.notifyError(response.msg, response.code);
              }
              this.loadingUnreserveAll = false;
            },
            (error) => {
              this.mtds.notifyError(error.statusText);
              this.loadingUnreserveAll = false;
            }
          );
        }
      }.bind(this)
    );
  }

  unreserve(onlyOne = null) {
    swal.fire({
      title: "Unreserve",
      text: "Are you sure to unreserve this items?",
      showCancelButton: true,
      buttonsStyling: false,
      customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then(
      function (result) {
        if (result.value) {
          this.loadingUnreserve = true;
          let json;
          json = {
            so_id: this.id,
            bulk: onlyOne === null ? this.arrayUnreserve : [onlyOne],
            freight: this.freight,
            serviches_charge: this.servichesCharge,
            misc_charge: this.misCcharge,
            tax: this.tax,
          };
          this._soService.unreserveItems(json).subscribe(
            (response) => {
              this.loadingUnreserve = false;
              console.log(response);
              if (response.code === 400) {
                localStorage.clear();
                this._router.navigate(["/"]);
              } else if (response.code === 200) {
                this.grossMargin = response.grossMarginTotal;
                this.marginPercentage = response.marginPercentage;
                this.tax = response.tax;
                this.subtotal = response.subtotal;
                this.total = response.total;

                this.freight = response.freight;
                this.misCcharge = response.misc_charge;
                this.servichesCharge = response.serviches_charge;

                this.new_freight.emit(response.freight);
                this.new_servichesCharge.emit(response.serviches_charge);
                this.new_misCcharge.emit(response.misc_charge);
                this.new_tax.emit(response.tax);
                this.new_subtotal.emit(response.subtotal);
                this.new_total.emit(response.total);
                this.save.emit(true);
                this.cleanLineItems(onlyOne);
                this.successUnreserve = false;
              } else {
                this.mtds.notifyError(response.msg, response.code);
                this.successUnreserve = false;
              }
            },
            (error) => {
              this.loadingUnreserve = false;
              this.loadingUnreserve = false;
              this.mtds.notifyError(error.statusText);
            }
          );
        }
      }.bind(this)
    );
  }

  cleanLineItems(onlyOne) {
    let index, tmp;
    tmp = this.lineItems;
    for (index = 0; index < this.lineItems.length; index++) {
      console.log();
      let i;
      for (i = 0; i < this.lineItems[index].reservedInventories.length; i++) {
        let unreserve;
        if (onlyOne === null) {
          for (unreserve of this.arrayUnreserve) {
            if (unreserve === this.lineItems[index].reservedInventories[i].id) {
              this.lineItems[index].reservedInventories.splice(i, 1);
              i--;
              break;
            }
          }
        } else if (
          onlyOne === this.lineItems[index].reservedInventories[i].id
        ) {
          this.lineItems[index].reservedInventories.splice(i, 1);
          i--;
          break;
        }
        if (this.lineItems[index].reservedInventories.length === 0) {
          this.lineItems[index].show = false;
        }
      }
    }
    this.arrayUnreserve = [];
  }

  parImpar(numero) {
    if (numero % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  rCondition(id): string {
    let item;
    for (item of this.conditions) {
      if (item.id == id) {
        return item.name;
      }
    }
    return "";
  }

  checkEditLineItem(id) {
    if (this.editLineItem_id === id) {
      return true;
    }
    return false;
  }

  editLineItem(id, value, type, index) {
    if (this.lineItems[index].reservedInventories.length === 0) {
      this.afterValue = value;
      this.typeChange = type;
      this.editLineItem_id = id;
    }
  }

  saveEditItem(value, index) {
    this.closeModal();
    if (value !== this.afterValue) {
      let json;
      json = {
        type: this.typeChange,
        value: value,
        group_id: this.editLineItem_id,
      };

      this._soService.editLineItem(json).subscribe(
        (response) => {
          if (response.status === "success") {
            this.mtds.notifySuccess("The field value was updated");
          } else {
            switch (this.typeChange) {
              case "quantity":
                this.lineItems[index].quantity = this.afterValue;
                break;
              case "height":
                this.lineItems[index].height = this.afterValue;
                break;
              case "unitprice":
                this.lineItems[index].unitPrice = this.afterValue;
                break;
              default:
                break;
            }
            this.mtds.notifyError(response.msg, response.code);
          }
          this.afterValue = null;
          this.typeChange = null;
          this.editLineItem_id = null;
        },
        (error) => {
          this.mtds.notifyError(error.statusText);
          this.afterValue = null;
          this.typeChange = null;
          this.editLineItem_id = null;
        }
      );
    } else {
      this.afterValue = null;
      this.typeChange = null;
      this.editLineItem_id = null;
    }
  }

  closeModal() {
    $("#myModal").modal("hide");
  }

  clqlrAVG(array: Array<any> = []) {
    let item,
      promedio = 0;

    if (array.length > 0) {
      for (item of array) {
        promedio = promedio + Number(item.unitcost);
      }

      promedio = promedio / array.length;
    }

    return promedio;
  }

  totalCost(array: Array<any> = []) {
    let item,
      total = 0;

    for (item of array) {
      total = total + Number(item.unitcost);
    }

    return total;
  }

  inTransit(idx) {
    const count = this.lineItems[idx].reservedInventories.filter(
      (obj) => obj.receivestatus === 'In Transit'
      ).length;

    return count;
  }

  openReserveModal(e, idx) {
    this.idx = idx;
    this.loadingReserve = true;
    $("#reserveModal").modal("show");

    this.serveLineItem = {
      id: e.id,
      so: this.so,
      rep: this.identity.name + " " + this.identity.surname,
      assoc: "",
      item: e.item,
      other: "",
      bulk: e.bulk,
      mfgr: e.manufacturer,
      condition: this.conditions_id,
      sellingPrice: e.unitPrice,
      showInTransitItems: true,
      showItemSubstitutea: false,
      showAllConditionsCodes: true,
      qtyToReserve: e.quantity,
      marked: e.reservedInventories.length,
      balanceToReserve: 1,
      markFirst: 1,
    };

    let json;
    json = {
      busqueda: e.item,
    };
    this._soService.reserveGroups(json).subscribe((response) => {
      console.log(response);
      this.individuales = response.dataFull;
      this.agrupados = response.data;
      this.agrupadosIds = response.dataId;
      this.agrupadosQty = response.dataCant;
      this.loadingReserve = false;
    });
  }

  eliminarLineItem(idx) {
    swal.fire({
      title: "Remove Sales Order",
      text: "Are you sure to delete this sales order?",
  
      showCancelButton: true,
      buttonsStyling: false,
     
      customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then(
      function (result) {
        if (result.value) {
          let tmp;
          tmp = this.lineItems.slice();
          tmp.splice(idx, 1);

          let json;
          json = {
            id: this.id,
            lineItems: tmp,
          };
          console.log(json);
          // console.log(JSON.stringify(json));

          this._soService.deleteLineItem(this.lineItems[idx].id).subscribe(
            (response) => {
              console.log(response);
              if (response.code === 200) {
                this.lineItems.splice(idx, 1);

                this.grossMargin = response.grossMarginTotal;
                this.marginPercentage = response.marginPercentage;
                this.tax = response.tax;
                this.subtotal = response.subtotal;
                this.total = response.total;

                this.freight = response.freight;
                this.misCcharge = response.misc_charge;
                this.servichesCharge = response.serviches_charge;

                this.new_freight.emit(response.freight);
                this.new_servichesCharge.emit(response.serviches_charge);
                this.new_misCcharge.emit(response.misc_charge);
                this.new_tax.emit(response.tax);
                this.new_subtotal.emit(response.subtotal);
                this.new_total.emit(response.total);
                this.save.emit(true);
              } else {
                this.mtds.notifyError(response.msg, response.code);
              }
              // this.save();
            },
            (error) => {
              this.mtds.notifyError(error.statusText);
            }
          );
        }
      }.bind(this)
    );
  }

  checkAllUnreserve(idx) {
    let item;
    for (item of this.lineItems[idx].reservedInventories) {
      if (!this.checkUnreserve(item.id)) {
        return false;
      }
    }
    return true;
  }

  checkUnreserve(id) {
    let i;
    for (i of this.arrayUnreserve) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  checkUnreserveItem(idx) {
    let item;
    for (item of this.lineItems[idx].reservedInventories) {
      if (this.checkUnreserve(item.id)) {
        return true;
      }
    }
    return false;
  }

  pushAllItemUnreserve(idx) {
    let agregar = false,
      item;
    if (!this.checkAllUnreserve(idx)) {
      agregar = true;
    }

    for (item of this.lineItems[idx].reservedInventories) {
      if (this.checkUnreserve(item.id)) {
        this.pushUnreserve(item.id);
      }
    }

    if (agregar) {
      for (item of this.lineItems[idx].reservedInventories) {
        this.pushUnreserve(item.id);
      }
    }
    console.log(this.arrayUnreserve);
  }

  pushUnreserve(id) {
    let i,
      idx = 0,
      find = false;
    for (i of this.arrayUnreserve) {
      if (i === id) {
        this.arrayUnreserve.splice(idx, 1);
        find = true;
        break;
      }
      idx++;
    }
    if (!find) {
      this.arrayUnreserve.push(id);
    }
  }

  orderBy(idx, order) {
    let i: number, n: number;
    if (this.lineItems[idx].order !== order) {
      this.lineItems[idx].order = order;
      this.lineItems[idx].ordenar = false;
    }
    for (i = 0; i < this.lineItems[idx].reservedInventories.length; i++) {
      for (n = i + 1; n < this.lineItems[idx].reservedInventories.length; n++) {
        switch (order) {
          case "line":
            if (
              (!this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].soLine >
                  this.lineItems[idx].reservedInventories[n].soLine) ||
              (this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].soLine <
                  this.lineItems[idx].reservedInventories[n].soLine)
            ) {
              let tmp;
              tmp = this.lineItems[idx].reservedInventories[i];
              this.lineItems[idx].reservedInventories[i] =
                this.lineItems[idx].reservedInventories[n];
              this.lineItems[idx].reservedInventories[n] = tmp;
            }
            break;
          case "po":
            if (
              (!this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].po.po +
                  "-" +
                  this.lineItems[idx].reservedInventories[i].poline >
                  this.lineItems[idx].reservedInventories[n].po.po +
                    "-" +
                    this.lineItems[idx].reservedInventories[n].poline) ||
              (this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].po.po +
                  "-" +
                  this.lineItems[idx].reservedInventories[i].poline <
                  this.lineItems[idx].reservedInventories[n].po.po +
                    "-" +
                    this.lineItems[idx].reservedInventories[n].poline)
            ) {
              let tmp;
              tmp = this.lineItems[idx].reservedInventories[i];
              this.lineItems[idx].reservedInventories[i] =
                this.lineItems[idx].reservedInventories[n];
              this.lineItems[idx].reservedInventories[n] = tmp;
            }
            break;
          case "sn":
            if (
              (!this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].serialnumber >
                  this.lineItems[idx].reservedInventories[n].serialnumber) ||
              (this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].serialnumber <
                  this.lineItems[idx].reservedInventories[n].serialnumber)
            ) {
              let tmp;
              tmp = this.lineItems[idx].reservedInventories[i];
              this.lineItems[idx].reservedInventories[i] =
                this.lineItems[idx].reservedInventories[n];
              this.lineItems[idx].reservedInventories[n] = tmp;
            }
            break;
          case "wh":
            if (
              (!this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].warehouse >
                  this.lineItems[idx].reservedInventories[n].warehouse) ||
              (this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].warehouse <
                  this.lineItems[idx].reservedInventories[n].warehouse)
            ) {
              let tmp;
              tmp = this.lineItems[idx].reservedInventories[i];
              this.lineItems[idx].reservedInventories[i] =
                this.lineItems[idx].reservedInventories[n];
              this.lineItems[idx].reservedInventories[n] = tmp;
            }
            break;
          case "status":
            if (
              (!this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].receivestatus >
                  this.lineItems[idx].reservedInventories[n].receivestatus) ||
              (this.lineItems[idx].ordenar &&
                this.lineItems[idx].reservedInventories[i].receivestatus <
                  this.lineItems[idx].reservedInventories[n].receivestatus)
            ) {
              let tmp;
              tmp = this.lineItems[idx].reservedInventories[i];
              this.lineItems[idx].reservedInventories[i] =
                this.lineItems[idx].reservedInventories[n];
              this.lineItems[idx].reservedInventories[n] = tmp;
            }
            break;
          default:
            break;
        }
      }
    }
    this.lineItems[idx].ordenar = !this.lineItems[idx].ordenar;
  }

  checkEditDescription(id) {
    let item;
    for (item of this.arrayEditDescription) {
      if (item.id === id) {
        return true;
      }
    }

    return false;
  }

  saveDescription(mdel, item_id, Description) {
    console.log(mdel);
    let json;
    json = {
      itemdesc: Description,
    };

    this.savingDescription = item_id;

    this._soService
      .updateDescriptionItem(item_id, json)
      .subscribe((response) => {
        this.savingDescription = null;
        this.successDescription = item_id;
        this.cancelEditDescirption(item_id);
        setTimeout(
          function () {
            this.successDescription = null;
          }.bind(this),
          1500
        );
      });
  }

  cancelEditDescirption(id) {
    let i,
      valor = "";
    for (i = 0; i < this.arrayEditDescription.length; i++) {
      if (this.arrayEditDescription[i].id === id) {
        valor = this.arrayEditDescription[i].value;
        this.arrayEditDescription.splice(i, 1);
        return valor;
      }
    }
  }

  editDescription(id, value) {
    let tmp: TMP;
    tmp = {
      id: id,
      value: value,
    };
    this.arrayEditDescription.push(tmp);
  }

  check(index) {
    let id;
    for (id of this.agrupadosIds[index]) {
      if (this.checkId(id)) {
        return true;
      }
    }
    return false;
  }

  checarGroup(index, event: boolean) {
    let id;
    for (id of this.agrupadosIds[index]) {
      if (
        !this.checkId(id) &&
        event &&
        this.serveLineItem.marked < this.serveLineItem.qtyToReserve
      ) {
        this.reserveIds.push(id);
        this.serveLineItem.marked++;
      } else if (this.checkId(id) && !event) {
        let i = 0,
          item;
        for (item of this.reserveIds) {
          if (item === id) {
            this.reserveIds.splice(i, 1);
            this.serveLineItem.marked--;
            break;
          }
          i++;
        }
      }
    }
  }

  checkId(id) {
    let item;
    for (item of this.reserveIds) {
      if (item === id) {
        return true;
      }
    }
    return false;
  }

  checarId(id) {
    let item,
      i = 0,
      find = false;
    for (item of this.reserveIds) {
      if (item === id) {
        find = true;
        this.reserveIds.splice(i, 1);
        this.serveLineItem.marked--;
        break;
      }
      i++;
    }

    if (!find && this.serveLineItem.marked < this.serveLineItem.qtyToReserve) {
      this.reserveIds.push(id);
      this.serveLineItem.marked++;
    }
  }

  closeReserveModal() {
    $("#reserveModal").modal("hide");
    this.idx = null;
    this.errorArray = [];
    this.reserveIds = [];
    this.individuales = [];
    this.agrupados = [];
    this.agrupadosIds = [];
    this.agrupadosQty = [];
    this.serveLineItem = {
      id: null,
      so: "",
      rep: "",
      assoc: "",
      item: "",
      other: "",
      bulk: false,
      mfgr: "1",
      condition: "",
      sellingPrice: "",
      showInTransitItems: true,
      showItemSubstitutea: false,
      showAllConditionsCodes: true,
      qtyToReserve: 1,
      marked: 0,
      balanceToReserve: 1,
      markFirst: 1,
    };
  }

  reserve() {
    this.errorArray = [];
    this.saving = true;
    this.loadingReserve = true;
    let json;
    json = {
      so_id: this.id,
      line_item_id: this.serveLineItem.id,
      bulk: this.reserveIds,
      freight: this.freight,
      serviches_charge: this.servichesCharge,
      misc_charge: this.misCcharge,
      tax: this.tax,
    };

    this._soService.reserveItems(json).subscribe(
      (response) => {
        console.log(response);
        this.loadingReserve = false;
        this.saving = false;

        if (response.code === 400) {
          localStorage.clear();
          this._router.navigate(["/"]);
        } else if (response.code === 200) {
          this.grossMargin = response.grossMarginTotal;
          this.marginPercentage = response.marginPercentage;
          this.tax = response.tax;
          this.subtotal = response.subtotal;
          this.total = response.total;

          this.freight = response.freight;
          this.misCcharge = response.misc_charge;
          this.servichesCharge = response.serviches_charge;

          this.new_freight.emit(response.freight);
          this.new_servichesCharge.emit(response.serviches_charge);
          this.new_misCcharge.emit(response.misc_charge);
          this.new_tax.emit(response.tax);
          this.new_subtotal.emit(response.subtotal);
          this.new_total.emit(response.total);
          this.status.emit(response.so_status);

          let rechazados;
          rechazados = [];
          if (response.errorArray.length > 0) {
            this.loadingReserve = true;

            let json3;
            json3 = {
              busqueda: this.serveLineItem.item,
            };

            this._soService.reserveGroups(json3).subscribe(
              (response3) => {
                console.log(response3);
                this.individuales = response3.dataFull;
                this.agrupados = response3.data;
                this.agrupadosIds = response3.dataId;
                this.agrupadosQty = response3.dataCant;
                this.loadingReserve = false;
              },
              (error3) => {
                this.loadingReserve = false;
                this.mtds.notifyError(error3.statusText);
              }
            );

            let error;
            for (error of response.errorArray) {
              let parts;
              parts = error.split(" - ");
              let elemento;
              elemento = {
                id: parts[0],
                item: parts[1],
              };
              rechazados.push(Number(parts[0]));
              this.errorArray.push(elemento);
              this.checarId(elemento.id);
              this.serveLineItem.marked--;
            }
          }

          let item, i;
          for (i = 0; i <= this.lineItems.length; i++) {
            if (this.lineItems[i].id === this.serveLineItem.id) {
              for (item of response.data) {
                this.lineItems[i].reservedInventories.push(item);
              }
              break;
            }
          }
          console.log(this.lineItems);

          this.successReserve = true;

          setTimeout(
            function () {
              this.successReserve = false;
            }.bind(this),
            3000
          );

          if (response.errorArray.length === 0) {
            this.closeReserveModal();
          }
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.loadingReserve = false;
        this.saving = false;
        this.mtds.notifyError(error.statusText);
      }
    );
  }
}
